function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoCadsoftPrimaryWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 6750 1900",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Cadsoft-Logo",
    transform: "matrix(9.92751,0,0,9.92751,24.4573,6.85255)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Cadsoft"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,-942.369,-1566.65)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M385.369,387.416C385.369,387.352 385.355,387.293 385.328,387.24C385.301,387.187 385.254,387.143 385.189,387.109C385.131,387.076 385.061,387.055 384.982,387.047C384.904,387.039 384.816,387.033 384.719,387.033L384.479,387.033L384.479,387.904L384.662,387.904C384.787,387.904 384.896,387.896 384.988,387.877C385.08,387.859 385.152,387.828 385.207,387.783C385.262,387.744 385.303,387.693 385.33,387.635C385.355,387.576 385.369,387.504 385.369,387.416ZM386.697,389.59L385.725,389.59L384.787,388.457L384.479,388.457L384.479,389.59L383.717,389.59L383.717,386.498L384.893,386.498C385.109,386.498 385.283,386.508 385.416,386.523C385.547,386.541 385.678,386.584 385.807,386.654C385.949,386.732 386.053,386.828 386.117,386.939C386.184,387.053 386.217,387.193 386.217,387.361C386.217,387.586 386.152,387.771 386.025,387.918C385.898,388.064 385.734,388.178 385.531,388.258L386.697,389.59ZM387.371,388.119C387.371,387.451 387.135,386.877 386.662,386.396C386.189,385.918 385.619,385.676 384.953,385.676C384.283,385.676 383.713,385.918 383.24,386.396C382.768,386.877 382.531,387.451 382.531,388.119C382.531,388.787 382.768,389.361 383.24,389.84C383.713,390.322 384.283,390.562 384.953,390.562C385.619,390.562 386.189,390.322 386.662,389.84C387.135,389.361 387.371,388.787 387.371,388.119ZM388.059,388.119C388.059,388.977 387.756,389.709 387.148,390.314C386.541,390.922 385.809,391.225 384.953,391.225C384.096,391.225 383.363,390.922 382.756,390.314C382.15,389.709 381.848,388.977 381.848,388.119C381.848,387.262 382.15,386.531 382.756,385.922C383.363,385.314 384.096,385.012 384.953,385.012C385.809,385.012 386.541,385.314 387.148,385.922C387.756,386.531 388.059,387.262 388.059,388.119Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,-942.369,-1566.65)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M382.859,396.725L379.189,396.725L379.189,404.971C379.189,406.404 380.029,406.719 381.322,406.719C381.811,406.719 382.334,406.648 382.859,406.648L382.859,411.016C381.775,411.051 380.693,411.191 379.609,411.191C374.543,411.191 373.25,409.723 373.25,404.797L373.25,396.725L370.244,396.725L370.244,392.881L373.25,392.881L373.25,387.395L379.189,387.395L379.189,392.881L382.859,392.881L382.859,396.725Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,-942.369,-1566.65)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M358.537,396.725L355.672,396.725L355.672,392.881L358.537,392.881C358.537,387.674 360.355,386.066 365.422,386.066C366.365,386.066 367.344,386.137 368.287,386.172L368.287,390.365C367.729,390.295 367.203,390.26 366.68,390.26C365.316,390.26 364.479,390.436 364.479,392.078L364.479,392.881L368.043,392.881L368.043,396.725L364.479,396.725L364.479,411.016L358.537,411.016L358.537,396.725Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,-942.369,-1566.65)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M344.967,406.998C347.727,406.998 348.602,404.271 348.602,401.966C348.602,399.66 347.727,396.899 344.967,396.899C342.207,396.899 341.367,399.66 341.367,401.966C341.367,404.271 342.207,406.998 344.967,406.998ZM344.967,392.357C350.592,392.357 354.541,396.516 354.541,401.966C354.541,407.417 350.592,411.54 344.967,411.54C339.342,411.54 335.428,407.417 335.428,401.966C335.428,396.516 339.342,392.357 344.967,392.357Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,-942.369,-1566.65)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M321.561,405.041C321.561,405.949 321.944,406.613 322.539,407.067C323.098,407.486 323.901,407.697 324.74,407.697C325.893,407.697 327.535,407.207 327.535,405.775C327.535,404.377 325.684,404.098 324.635,403.854C320.896,402.909 316.214,402.805 316.214,397.912C316.214,393.545 320.932,392.357 324.496,392.357C328.479,392.357 332.637,393.51 332.847,398.227L327.361,398.227C327.361,397.459 327.081,396.969 326.592,396.654C326.103,396.34 325.439,396.2 324.705,396.2C323.727,396.2 322.154,396.305 322.154,397.563C322.154,399.275 326.138,399.59 328.863,400.184C332.532,400.918 333.477,403.573 333.477,405.076C333.477,409.934 328.863,411.54 324.775,411.54C320.477,411.54 316.074,410.107 315.899,405.041L321.561,405.041Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,-942.369,-1566.65)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M300.726,401.756C300.726,404.237 301.634,406.998 304.359,406.998C307.26,406.998 307.889,404.237 307.889,401.932C307.889,399.311 306.946,396.899 304.359,396.899C301.634,396.899 300.726,399.45 300.726,401.756ZM313.619,411.016L307.959,411.016L307.959,408.92L307.889,408.92C306.735,410.632 304.989,411.54 302.893,411.54C297.197,411.54 294.786,406.648 294.786,401.547C294.786,396.83 297.302,392.357 302.438,392.357C304.674,392.357 306.387,393.195 307.609,394.838L307.68,394.838L307.68,386.066L313.619,386.066L313.619,411.016Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,-942.369,-1566.65)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M283.375,407.871C286.206,407.871 287.149,406.264 287.009,402.525C286.17,403.049 284.633,403.154 283.34,403.504C282.013,403.818 280.895,404.377 280.895,405.809C280.895,407.277 282.047,407.871 283.375,407.871ZM275.688,398.472C275.792,396.096 276.912,394.558 278.519,393.615C280.125,392.706 282.223,392.357 284.285,392.357C288.583,392.357 292.74,393.301 292.74,398.437L292.74,406.369C292.74,407.906 292.74,409.584 293.438,411.016L287.463,411.016C287.253,410.457 287.185,409.898 287.114,409.304C285.577,410.911 283.306,411.54 281.14,411.54C277.68,411.54 274.955,409.793 274.955,406.055C274.955,400.148 281.383,400.604 285.506,399.765C286.521,399.555 287.08,399.205 287.08,398.088C287.08,396.725 285.438,396.2 284.213,396.2C282.571,396.2 281.523,396.933 281.245,398.472L275.688,398.472Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,-942.369,-1566.65)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M261.983,406.514C257.812,406.514 256.212,402.828 256.212,399.143C256.212,399.121 256.213,399.1 256.213,399.078L250.154,402.607C251.459,408.094 255.871,412.076 262.125,412.076C268.417,412.076 273.112,408.322 273.458,401.924L266.991,401.924C266.748,404.775 265.009,406.514 261.983,406.514Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,-942.369,-1566.65)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M261.983,391.771C264.696,391.771 266.644,393.092 266.991,395.596L273.458,395.596C273.283,389.615 267.479,386.208 262.125,386.208C256.081,386.208 251.752,389.926 250.291,395.127L256.229,398.591C256.381,395.098 258.021,391.771 261.983,391.771Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Diamond"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,-942.369,-1566.65)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M245.886,400.275L226.331,400.275L247.648,421.589L254.866,414.371C253.102,413.52 251.535,412.363 250.248,410.959C247.607,408.102 246.119,404.321 245.886,400.275Z",
    style: {
      fill: "rgb(229,27,36)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,-942.369,-1566.65)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M250.248,387.326C251.648,385.795 253.381,384.559 255.339,383.695L247.648,376.004L226.278,397.373L245.922,397.373C246.269,393.566 247.746,390.033 250.248,387.326Z",
    style: {
      fill: "rgb(229,27,36)",
      fillRule: "nonzero"
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCadsoftPrimaryWhite);
export default __webpack_public_path__ + "static/media/logo-cadsoft-primary-white.0318521f914ce509c7e70105a32312a2.svg";
export { ForwardRef as ReactComponent };